import React from "react";

export default function renderLoader(isLoading) {
    return (
        <section id="loading-screen">
            <div id="loader"/>
        </section>
    )
}
